module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teachersInKlassSameTime.length > 0),
      expression: "teachersInKlassSameTime.length > 0"
    }]
  }, [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.lessons_that_overlap_in_class')) + "\n  ")]), _vm._v(" "), _c('ul', [_vm._l((_vm.teachersInKlassSameTime), function(userAndLesson, key) {
    return (_vm.isShowAllTeachers || key < _vm.numberOfTeachersToShow) ? _c('li', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'left',
          boundary: 'window',
          zIndex: 2147483010
        }),
        expression: "{\n                  arrow: true,\n                  placement: 'left',\n                  boundary: 'window',\n                  zIndex: 2147483010\n                }"
      }],
      key: userAndLesson.user.user_calendar_id,
      staticClass: "small-lesson",
      class: {
        'user--is-absent': userAndLesson.user.v_overlapping_absence.length > 0
      },
      style: ({
        'border-left-color': userAndLesson.lesson.color
      }),
      attrs: {
        "content": userAndLesson.user.v_overlapping_absence.length < 1 ? userAndLesson.lesson.v_title : userAndLesson.user.v_overlapping_absence
      }
    }, [(userAndLesson.user.v_is_substitute) ? _c('span', {
      staticClass: "icon-users"
    }) : _vm._e(), _vm._v("\n      " + _vm._s(userAndLesson.user.name) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), (_vm.teachersInKlassSameTime.length > _vm.numberOfTeachersToShow) ? _c('li', {
    staticClass: "text-link",
    on: {
      "click": function($event) {
        _vm.isShowAllTeachers = !_vm.isShowAllTeachers
      }
    }
  }, [(!_vm.isShowAllTeachers) ? [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_more')) + " (" + _vm._s(_vm.numberOfTeachersHidden) + ")\n      ")] : [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_less')) + "\n      ")]], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a147321!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/LessonOverlapInKlass.vue
// module id = 1823
// module chunks = 1